
import { omit } from '../../utils/miscellaneous/objectHelpers';
import { methodsActionTypes } from '../../constants/actionTypes/ssapActionTypes';

export const INITIAL_STATE = {};

export default (state = INITIAL_STATE, action = {}) => {
    switch(action.type) {
        case methodsActionTypes.SET_METHODS:
            return {
                ...state,
                [action.owner]: action.methods
            };
        case methodsActionTypes.CLEAR_METHODS:
            return omit(state, action.owner);
        case methodsActionTypes.CLEAR_SSAP_STATE:
            return INITIAL_STATE;
        default:
            return state;
    }
};
